import React from 'react';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const SalesComponentForm = () => {
  return (
    <div> <h2 className="text-left mb-4 text-dark">Parameters</h2>
    <Form
      action="/submit-report"
      method="post"
      style={{ maxWidth: '700px', padding: '20px', borderTop: '5px solid #007bff', border: '1px solid #ced4da', borderRadius: '0.25rem', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', backgroundColor: '#f8f9fa',marginTop:"10px" }}
    >
      <fieldset>
    

        <Form.Group as={Row} controlId="startDate">
          <Form.Label column sm={4} title="Please choose a start date to report on">
            Start Date <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control
              type="date"
              id="sales-component-start-date"
              name="start_date"
              required
              defaultValue="2024-09-01"
              style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="endDate">
          <Form.Label column sm={4} title="Please choose an end date to report on">
            End Date <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control
              type="date"
              id="sales-component-end-date"
              name="end_date"
              required
              defaultValue="2024-09-30"
              style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="componentFilter">
          <Form.Label column sm={4} title="Please choose components to filter the report by">
            Components
          </Form.Label>
          <Col sm={8}>
            <Form.Check
              type="radio"
              name="component_filter"
              id="include"
              value="include"
              label="Include"
              defaultChecked
              style={{ marginRight: '10px' }}
            />
            <Form.Check
              type="radio"
              name="component_filter"
              id="exclude"
              value="exclude"
              label="Exclude"
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="salesComponent">
          <Form.Label column sm={4} title="Please choose component to filter the report by">
            Components
          </Form.Label>
          <Col sm={8}>
            <Form.Control
              as="select"
              name="component[]"
              id="sales_component"
              multiple
              size="10"
              style={{ height: 'auto', borderRadius: '0.25rem', borderColor: '#ced4da' }}
            >
              <option value="" selected>All</option>
              <optgroup label="GUM">
                <option value="1">GUM WORK COMPOSITE</option>
              </optgroup>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="category">
          <Form.Label column sm={4} title="Please choose a component category">
            Category
          </Form.Label>
          <Col sm={8}>
            <Form.Control
              as="select"
              name="category"
              id="sales_component_category"
              style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
            >
              <option value="">All</option>
              <option value="GUM">GUM</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="format">
          <Form.Label column sm={4} title="Please choose a display format">
            Format <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control
              as="select"
              name="format"
              id="sales_component_format"
              style={{ borderRadius: '0.25rem', borderColor: '#ced4da' }}
            >
              <option value="">On Screen</option>
              <option value="csv">CSV (Excel)</option>
            </Form.Control>
          </Col>
        </Form.Group>

       
               <Form.Group as={Row}>
                       <Col sm={{ span: 8, offset: 4 }}>
                         <Link to="/Addcomponent">
                           <Button
                             id="pay-per-task-submit"
                             type="button"
                             variant="primary"
                             className="w-100 mt-2"
                             style={{
                               backgroundColor: '#004aad',
                               borderColor: '#004aad',
                               marginTop: '10px',
                             }}
                           >
                             Run
                           </Button>
                         </Link>
                       </Col>
                      </Form.Group>
      </fieldset>
    </Form>
    </div>
  );
};

export default SalesComponentForm;
